<template>
  <div>
    <!--scheduler toolbar component-->
    <tool-bar title="Scheduler"></tool-bar>
    <!--start of container-->
    <v-container
      grid-list-xl
      class="page-container"
      :class="{ 'py-3': !isMobile, 'mobile': isMobile }">
      <v-layout row wrap>
        <!--add provider button-->
        <v-flex xs12 sm6 :class="{'pb-0': isMobile}">
          <v-tooltip :disabled="!showTooltip" top>
            <v-btn
              class="add-by-button"
              :class="{ active: addBy === 'PROVIDER' }"
              slot="activator"
              block
              @click="addBy = 'PROVIDER'">
              Add by provider
            </v-btn>
            <span>Select provider and add to student service</span>
          </v-tooltip>
        </v-flex>
        <!--add student button-->
        <v-flex xs12 sm6 :class="{'pt-0': isMobile}">
          <v-tooltip :disabled="!showTooltip" top>
            <v-btn
              class="add-by-button"
              :class="{ active: addBy === 'STUDENT' }"
              slot="activator"
              block
              @click="addBy = 'STUDENT'">
              Add by student
            </v-btn>
            <span>Select student and add provider(s) to service</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!--add by provider-->
      <provider-add v-if="addBy === 'PROVIDER'" :showTooltip="showTooltip"></provider-add>
      <!--add by student-->
      <student-add v-if="addBy === 'STUDENT'" :showTooltip="showTooltip"></student-add>
      <!--botttom navigation for mobile devices-->
      <bottom-nav></bottom-nav>
      <!--app loading page-->
      <full-screen-loading-spinner v-if="showLoading"></full-screen-loading-spinner>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Toolbar from '@/components/toolbar';
import BottomNav from '@/components/bottom-nav';
import FullScreenLoadingSpinner from '@/components/full-screen-loading-spinner';
import ProviderAdd from '@/components/scheduler/add-by-provider';
import StudentAdd from '@/components/scheduler/add-by-student';

export default {
  name: 'Scheduler',
  components: {
    Toolbar,
    BottomNav,
    FullScreenLoadingSpinner,
    ProviderAdd,
    StudentAdd
  },
  data() {
    return {
      addBy: 'PROVIDER',
      showLoading: false
    };
  },
  computed: {
    ...mapGetters({
      showTooltip: 'showTooltip'
    }),
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  }
};
</script>

<style lang="scss" scoped>
  .add-by-button {
    height: 100px;
    font-size: 20px;
    background-color: #fafafa !important;
    color: var(--v-secondary-base);
    border-radius: 10px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2) !important;
    &.active {
      background-color: var(--v-secondary-base) !important;
      color: #fff;
      font-weight: bold;
      box-shadow: 0 0 15px rgba(65, 88, 191, 0.7) !important;
    }
  }
  .mt-50 {
    margin-top: 50px;
  }

  .padding-right {
    padding-right: 3px;
  }

  .icon-padding {
    padding-right: 10px;
  }

  .actionButton {
    width: 145px;
  }

  .actionButton-tablet {
    width: 105px;
  }

  .studentInfo {
    font-size: 1.2em;
    padding: 10px;
  }

  .small {
    font-size: 80%;
  }

  .mobile-padding {
    padding-left: 3px;
    padding-right: 3px;
  }

  .table-padding {
    padding-left: 25px;
    margin-top: 10px;
  }

  .border-bottom {
    border-bottom: 1px solid black;
  }

  .add-new-provider {
    width: 100%;
    height: 70%;
    border-bottom: 1px solid black;
    padding: 5px;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/scheduler/scheduler-container.vue